import { useContext } from 'react';
import { TourContext, type TourContextType } from './TourProvider';

export function useTour(): TourContextType {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
}
